import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useToasts } from 'react-toast-notifications'
import { selectVbError, selectIsSuccessfullyUploaded } from './reducer'
import { clearToastStates } from './actions'
import { updateStatus } from '../root/actions'
import * as constants from './constants'

export const useVBNotifications = () => {
  const error = useSelector(selectVbError)
  const dispatch = useDispatch()
  const { addToast, removeAllToasts } = useToasts()
  const isSuccessfullyUploaded = useSelector(selectIsSuccessfullyUploaded)

  useEffect(() => {
    // Prevent toasts from stacking
    removeAllToasts()

    if (error) {
      const mappedMessage = mapVbErrorToToastOptions(error)
      addToast('', mappedMessage)
      dispatch(updateStatus(mappedMessage.message))
    } else if (isSuccessfullyUploaded) {
      // success case
      addToast('', {
        appearance: 'success',
        autoDismiss: true,
        autoDismissTimeout: 3000,
        message: 'Your background is set.',
      })
    }

    if (error || isSuccessfullyUploaded) {
      return () => dispatch(clearToastStates())
    }
  }, [error, isSuccessfullyUploaded, addToast, removeAllToasts, dispatch])

  return error
}

function mapVbErrorToToastOptions(error) {
  const toastOptions = {
    10012: {
      appearance: 'info',
      autoDismiss: false,
      message: constants.ENABLE_VB_ERROR_TOAST_MESSAGE,
    },
    10017: {
      appearance: 'info',
      autoDismiss: true,
      autoDismissTimeout: 3000,
      message: constants.CONSENT_REJECTION_ERROR,
    },
    10020: {
      appearance: 'info',
      autoDismiss: false,
      message: constants.ENABLE_CAMERA_ERROR_TOAST_MESSAGE,
    },
    10045: {
      appearance: 'info',
      autoDismiss: false,
      message: (
        <div className="download-vb-package-message">
          {constants.DOWNLOAD_VB_PACKAGE}
        </div>
      ),
    },
  }

  const defaultErrorToastOptions = {
    appearance: 'error',
    autoDismiss: false,
    message: constants.DEFAULT_ERROR_TOAST_MESSAGE,
  }

  const t = toastOptions[error.code]

  return t || defaultErrorToastOptions
}
